import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import { CALENDAR_DOW, MONTHS_VN } from "./constants";

export default function LotteryDatePicker({ value, onChange, maxDate }) {
  const selected = dayjs(value);
  const [cursor, setCursor] = useState(selected.startOf("month"));
  const max = maxDate ? dayjs(maxDate) : dayjs();

  useEffect(() => {
    const next = dayjs(value);
    if (next.isValid()) setCursor(next.startOf("month"));
  }, [value]);

  const cells = useMemo(() => {
    const start = cursor.startOf("month");
    const startWeekday = (start.day() + 6) % 7;
    const daysInMonth = cursor.daysInMonth();
    const items = [];

    for (let i = 0; i < startWeekday; i += 1) {
      const d = start.subtract(startWeekday - i, "day");
      items.push({ date: d, outside: true });
    }
    for (let day = 1; day <= daysInMonth; day += 1) {
      items.push({ date: start.date(day), outside: false });
    }
    while (items.length % 7 !== 0) {
      const last = items[items.length - 1].date;
      items.push({ date: last.add(1, "day"), outside: true });
    }
    return items;
  }, [cursor]);

  const canNext = cursor.isBefore(max, "month");

  return (
    <div className="xoso-box xoso-datepicker">
      <div className="xoso-datepicker__nav">
        <button
          type="button"
          className="xoso-datepicker__nav-btn"
          onClick={() => setCursor((c) => c.subtract(1, "month"))}
          aria-label="Tháng trước"
        >
          <ChevronLeftIcon width={14} height={14} />
        </button>
        <div className="xoso-datepicker__month">
          {MONTHS_VN[cursor.month()]} {cursor.year()}
        </div>
        <button
          type="button"
          className="xoso-datepicker__nav-btn"
          onClick={() => canNext && setCursor((c) => c.add(1, "month"))}
          aria-label="Tháng sau"
          disabled={!canNext}
        >
          <ChevronRightIcon width={14} height={14} />
        </button>
      </div>
      <div className="xoso-datepicker__dow">
        {CALENDAR_DOW.map((d) => (
          <span key={d}>{d}</span>
        ))}
      </div>
      <div className="xoso-datepicker__grid">
        {cells.map(({ date, outside }) => {
          const key = date.format("YYYY-MM-DD");
          const disabled = date.isAfter(max, "day");
          const isSelected = date.isSame(selected, "day");
          const isToday = date.isSame(dayjs(), "day");
          return (
            <button
              key={key}
              type="button"
              disabled={disabled}
              className={[
                "xoso-datepicker__day",
                outside ? "is-outside" : "",
                isSelected ? "is-selected" : "",
                isToday ? "is-today" : "",
              ].join(" ")}
              onClick={() => onChange(key)}
            >
              {date.date()}
            </button>
          );
        })}
      </div>
    </div>
  );
}
